'use client'

import { useState } from "react";
import RoleSearch from "./RoleSearch";
import RoleScroll from "./RoleScroll";
import Modal from "@/components/Modal/Modal";
import RoleForm from "@/components/RoleForm/RoleForm";
import { NewRole, Role } from "@/types/role";
import addRole from "@/services/UserService/addRole";
import RolePermissionsList from "./RolePermissionsList/RolePermissionsList";

const RoleListView = () => {
    const [filter, setFilter] = useState('');
    const [isCreateRoleModalOpen, setIsCreateRoleModalOpen] = useState(false);
    const [reloadRolesTrigger, setReloadRolesTrigger] = useState(false);
    const [selectedRole, setSelectedRole] = useState<Role>();
    const handleOnSearch = (value: string) => {
      setFilter(value);
    }

    const handleOnRoleSubmit = async (newRole: NewRole) => {
      const response = await addRole(newRole);
  
      if (response) {
        setIsCreateRoleModalOpen(false);
        setReloadRolesTrigger(prev => !prev)
      }
    }

    const handleSetSelectedRole = (role: Role) => {
      setSelectedRole(role)
    }
    
    return (
        <div>
            <Modal isOpen={isCreateRoleModalOpen} onClose={() => setIsCreateRoleModalOpen(false)} title={"Add new role"} className={"!w-[500px]"}>
                <RoleForm onSubmit={handleOnRoleSubmit} />
            </Modal>
            <Modal
                isOpen={!!selectedRole}
                onClose={() => setSelectedRole(undefined)}
                title="Manage Role"
                className="!p-0"
            >
                {selectedRole && (
                    <div className="w-[650px] max-w-[calc(100vw-128px)]">
                        <div className="border-b border-gray-200 bg-gray-50">
                            <div className="flex flex-col gap-xs px-xl pb-xl pt-xl">
                                <div className="text-title-xl capitalize text-gray-900">
                                    {selectedRole.name || 'Unnamed Role'}
                                </div>
                                <div className="inline-flex items-center gap-sm text-text-md text-gray-400">
                                    {selectedRole.description}
                                </div>
                            </div>
                        </div>
                        <div className="p-md">
                            <RolePermissionsList role={selectedRole}/>
                        </div>
                    </div>
                )}
            </Modal>
            <RoleSearch
                onSearch={handleOnSearch}
                setIsCreateRoleModalOpen={setIsCreateRoleModalOpen}
            />
            <div className="mt-xxl h-full w-full">
                <RoleScroll
                    reloadRolesTrigger={reloadRolesTrigger}
                    filter={filter}
                    onSelectedRoleChange={handleSetSelectedRole}
                />
            </div>
            
        </div>
    )
}

export default RoleListView;
